import { GET } from '../api';

import type { Locales, StrapiFilterParams } from '@monoimin/sb-types';

export type CheckExistenceByFieldResponse = Awaited<
  ReturnType<typeof checkEstateExistenseByField>
>;

/**
 *
 * @param field ключ multi-select или enum поля, например, 'object_type'
 * @param filters любые фильтры по полям, например, чтобы получить результат для объектов в Греции `{ country: { code: 'GR' } }`
 * @returns `{
 * data: {
 *   "residential-complex": true,
 *   "apartments": true
 *  }
 * }` пример ответа для поля object_type
 */
export async function checkEstateExistenseByField({
  field,
  filters,
  locale = 'en',
}: {
  field: string;
  filters?: StrapiFilterParams;
  locale?: Locales;
}) {
  const queryObject: { locale: Locales; filters?: StrapiFilterParams } = {
    locale,
  };

  if (filters) {
    queryObject.filters = filters;
  }
  const { data } = await GET('/estates/check-existense-by-field/{field}', {
    params: {
      path: {
        field,
      },
      query: queryObject,
    },
  });

  return data;
}

export default checkEstateExistenseByField;
